var Brige = require('../titans/bridge');
var dpmerchant = require('./prefix-methods').dpmerchant;
var getUA = require('../common/get-ua')

var UA = getUA.internal()

var PREFIX_APIS = dpmerchant.map(function (item){
    return item.methodName;
});
var APOLLO_SPLIT_VERSION = '3.0.3.0';

var MERCHANT_SPLIT_VERSION = '6.2.0';

/**
 * android and appVersion > [APOLLO_SPLIT_VERSION, MERCHANT_SPLIT_VERSION]
 * 如果能在 阿波罗或者点评管家用这个版本的话，理论上应该都是最新版本了。
 * NOTE: 在安卓中，给特定的api添加前缀
 * 配置的地址为 http://git.sankuai.com/mvc/projects/KNB/repos/knb-biz/browse/dpmerchant/methods.json
 * @param methodName
 * @return {string}
 */
function checkIfAddPrefix(methodName) {
  var prefix = '';
  if(UA.osName === 'android'){
      prefix = 'dpmerchant';
  }
  if(!prefix) return methodName;
  return PREFIX_APIS.indexOf(methodName) !== -1 ? (prefix + "." + methodName) : methodName;
}

function _sendMessage (method, args, callback){
    // TODO check add prefix
    var method_prefix = checkIfAddPrefix(method);
    Brige.doSendMessage.call(Brige, method_prefix, args, callback);
}

function _send (method, args) {
    // TODO check add prefix
    var method_prefix = checkIfAddPrefix(method);
    Brige.callNative.call(Brige, method_prefix, args);
}

function convertUrlParams (params){
    var result = [];
    for(var i in params){
        result.push(i + "=" + encodeURIComponent(params[i]));
    }
    return result.join("&");
}

module.exports = {
  APOLLO_SPLIT_VERSION: APOLLO_SPLIT_VERSION,
  MERCHANT_SPLIT_VERSION: MERCHANT_SPLIT_VERSION,
  checkIfAddPrefix: checkIfAddPrefix,
  _sendMessage: _sendMessage,
  _send: _send,
  convertUrlParams: convertUrlParams
}


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/dpzeus/utils.js
// module id = 520
// module chunks = 0